<div class="header-bar">
  <h1>Self-Billing Agreements</h1>
</div>
<div class="" style="position: relative">
  <div class="content-container">
    <form (ngSubmit)="search()" style="width: 100%">
      <div class="ui-g filterPanel">
        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <p-dropdown
            name="selfBillingStatus"
            [options]="selfBillingStatuses"
            [(ngModel)]="filterVal.filters.selfBillingStatus.value"
            styleClass="filterItem"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2" style="width: auto">
          <button
            pButton
            type="button"
            label="Clear"
            class="ui-button btn-to-right"
            (click)="clearFilter(dt)"
          ></button>
          <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
        </div>
      </div>
    </form>

    <p-table
      #dt
      [value]="page.items"
      [lazy]="true"
      [rows]="10"
      [responsive]="true"
      [paginator]="true"
      [rowHover]="true"
      resizableColumns="true"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
      [(selection)]="selectedAgreement"
      [sortField]="filterVal.sortField"
      [sortOrder]="filterVal.sortOrder"
      [hidden]="!isLoaded"
      selectionMode="single"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [first]="filterVal.first"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="organisationName">Supplier</th>
          <th pSortableColumn="agreed">Is Agreed</th>
          <th pSortableColumn="commitedOn">Committed On</th>
          <th pSortableColumn="isActive">Active</th>
          <th pSortableColumn="expireStatus">Expiring/Expired</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>
            <a href="#" (click)="openSupplierDetails(item); $event.preventDefault()">{{
              item.organisationName
            }}</a>
          </td>
          <td>{{ item.agreed == null ? '' : item.agreed ? 'Agreed' : 'Declined' }}</td>
          <td>{{ item.commitedOn | datex : 'DD MMM YYYY' }}</td>
          <td>{{ item.isActive ? 'Yes' : 'No' }}</td>
          <td>{{ item.isExpiring ? 'Expiring' : item.isExpired ? 'Expired' : '' }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED

          <p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" [rowHover]="true"
                       resizableColumns="true" [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" [(selection)]="selectedAgreement"
                       [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder" [hidden]="!isLoaded" selectionMode="single" [rowsPerPageOptions]="[5,10,20]"
                       [pageLinks]="3" [first]="filterVal.first">
              <p-column field="organisationName" header="Supplier" [sortable]="tru">
                  <ng-template let-col let-item="rowData" pTemplate="body">
                      <a href='#' (click)="openSupplierDetails(item);$event.preventDefault();">{{item[col.field]}}</a>
                  </ng-template>
              </p-column>
              <p-column field="agreed" header="Is Agreed" [sortable]="tru" styleClass="align-center">
                  <ng-template let-col let-item="rowData" pTemplate="body" styleClass="align-center">
                      {{item[col.field]==null ? '' : (item[col.field] ? 'Agreed' : 'Declined')}}
                  </ng-template>
              </p-column>
              <p-column field="commitedOn" header="Commited On" [sortable]="tru" styleClass="align-center">
                  <ng-template let-col let-item="rowData" pTemplate="body">
                      {{ item[col.field] | datex:'DD MMM YYYY' }}
                  </ng-template>
              </p-column>
              <p-column field="isActive" header="Active" [sortable]="tru" styleClass="align-center">
                  <ng-template let-col let-item="rowData" pTemplate="body">
                      {{item[col.field] ? 'Yes' : 'No'}}
                  </ng-template>
              </p-column>
              <p-column field="expireStatus" header="Expiring/Expired" [sortable]="tru" styleClass="align-center">
                  <ng-template let-col let-item="rowData" pTemplate="body">
                      {{item.isExpiring ? 'Expiring' : (item.isExpired ? 'Expired' : '')}}
                  </ng-template>
              </p-column>
          </p-dataTable>

          -->

    <div class="footerPanel ui-grid-row">
      <button
        pButton
        class="btn-to-right"
        (click)="editAgreement()"
        icon="fa ui-icon-edit"
        label="Edit"
        [disabled]="!selectedAgreement"
      ></button>

      <!--                <button pButton class="btn-to-right" (click)="addAgreement()" icon="fa ui-icon-add"-->
      <!--                        label="Add"></button>-->
    </div>
  </div>
</div>

<p-dialog
  header="Edit Self-Billing Agreement"
  [(visible)]="showEditAgreementDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
  (onHide)="onEditAgreementDlgHide()"
>
  <form
    [formGroup]="editingAgreementForm"
    (submit)="submitEditAgreement(); showEditAgreementDlg = false"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-grid-row">
        <div class="ui-g-4" style="padding-top: 20px"><label for="isAgreed">Is Agreed:</label></div>
        <div class="ui-g-8">
          <p-checkbox id="isAgreed" binary="true" formControlName="agreed"></p-checkbox>
        </div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-4"><label for="commitedOn">Commited On:</label></div>
        <div class="ui-g-8">
          <p-calendar
            id="commitedOn"
            inputId="commitedOn"
            formControlName="commitedOn"
            [showIcon]="true"
            [inline]="false"
            dateFormat="dd/mm/yy"
            appendTo="body"
          ></p-calendar>
        </div>
      </div>
      <!--            <div class="ui-grid-row">-->
      <!--                <div class="ui-g-4"><label for="isActive">IsActive:</label></div>-->
      <!--                <div class="ui-g-8">-->
      <!--                    <p-checkbox id="isActive" name="isActive" binary="true" required-->
      <!--                                [(ngModel)]="editingAgreement.isActive"></p-checkbox>-->
      <!--                </div>-->
      <!--            </div>    -->
      <br />
      <div class="ui-grid-row" style="float: right; margin-bottom: 10px">
        <button
          class="green-btn"
          pButton
          [disabled]="editingAgreementForm.invalid"
          icon="fa ui-icon-check"
          label="Save"
        ></button>
        <button
          type="button"
          pButton
          icon="fa ui-icon-close"
          label="Close"
          (click)="showEditAgreementDlg = false"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<!--<p-dialog header="Add Self-Billing Agreement" [(visible)]="showAddAgreementDlg"-->
<!--          [responsive]="true"  [modal]="true" [width]="500" (onHide)="onAddAgreementDlgHide()">-->
<!--    <form #editForm [autocomplete]="false" (submit)="submitAddAgreement(); showAddAgreementDlg = false;">-->
<!--        <div class="ui-grid ui-grid-responsive ui-fluid">-->
<!--            <div class="ui-grid-row">-->
<!--                <div class="ui-g-4"><label for="supplier">Supplier:</label></div>-->
<!--                <div class="ui-g-8">-->
<!--                    <p-dropdown id="supplier" inputId="supplier" name="supplier" required-->
<!--                                [options]="supplierOpts" [(ngModel)]="supplierToAddId"></p-dropdown>-->
<!--                </div>-->
<!--            </div>-->
<!--            <br/>-->
<!--            <div class="ui-grid-row" style="float:right; margin-bottom:10px">-->
<!--                <button class="green-btn" pButton icon="fa ui-icon-check" label="Save"></button>-->
<!--                <button type="button" pButton icon="fa ui-icon-close" label="Close" (click)="showAddAgreementDlg = false;"></button>-->
<!--            </div>-->
<!--        </div>-->
<!--    </form>-->
<!--</p-dialog>-->
